import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AppFacadeService } from '../../../services/app-facade.service';
import { DateFormatType } from '../../../enums/date-format-type.enum';
import { AppMediatorService } from '../../../services/app-mediator.service';
import { DialogContentType } from '../../../enums/dialog-type.enum';
import { TransactionResultEnum } from '../../../payment/models/paymentOutput';

@Component({
    standalone: false,
    selector: 'por-payment-success-dialog',
    templateUrl: './payment-success-dialog.component.html',
    styleUrls: ['./payment-success-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentSuccessDialogComponent {
    readonly appFacadeService = inject(AppFacadeService);
    readonly appMediatorService = inject(AppMediatorService);

    dialogContentType = DialogContentType;
    dialogMessage = '';
    dateFormat: DateFormatType = DateFormatType.StandardDateTime;
    transactionResultEnum = TransactionResultEnum;
}
